import type { Duration, Onset, Pixel } from './units/UnitValue';

/**
 * Blocks Lines Cells static constants
 */
export class BLC {
  static rowHeight = 150 as Pixel;

  static pixelByOnset = 100 as Pixel;
}

export class Cell {
  duration: Duration;

  onset: Onset;

  constructor(duration: Duration | number, onset:Onset | number) {
    this.duration = duration as Duration;
    this.onset = onset as Onset;
  }
}

export class Line {
  cells: Cell[];

  constructor(cells: Cell[]) {
    this.cells = cells;
  }

  getDuration(): Duration {
    return this.cells
      .map((cell) => cell.duration)
      .reduce((previous, current) => (previous + current) as Duration);
  }
}

export class Block {
  lines: Line[];

  constructor(lines: Line[]) {
    this.lines = lines;
  }

  getDuration(): Duration {
    return this.lines
      .map((line) => line.getDuration())
      .reduce((previous, current) => (previous + current) as Duration);
  }

  getHeight(): number {
    const verticalSpaceAfterBlock = 50;
    return (this.lines.length) * BLC.rowHeight + verticalSpaceAfterBlock;
  }
}
